import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

export const Itogi = () => (
	<Switch>
		<Route path="/admin/itogi" exact component={List} />
		<Route path="/admin/itogi/create" component={Edit} />
		<Route path="/admin/itogi/:id" component={Edit} />
	</Switch>
);
